import styled from "@emotion/styled";
import TextField from "@components/form/TextField";
import ButtonComponent from "@components/Button";

import { theme } from "@styles/theme";
const { lg, xl } = theme.breakpoints;

export const Container = styled.form`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  margin-top: 5vh;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 3vh;

  @media (max-width: ${xl}) {
    font-size: 11px;
  }
  @media (max-width: ${lg}) {
    flex-direction: column;
    padding: 2vh 0;
    font-size: 14px;
  }
`;
export const Label = styled.div`
  color: #6d6d6d;
  font-family: Poppins Regular;
  @media (max-width: ${lg}) {
    width: 92%;
    margin-bottom: 2em;
  }
`;
export const FormGroup = styled.div`
  position: relative;
  width: 22%;
  @media (max-width: ${lg}) {
    width: 90%;
    margin-bottom: 2em;
  }
`;
export const Document = styled(TextField)`
  width: 100%;
  font-size: 1em;
  background-color: #f8f8f8;
  color: hsl(0, 0%, 50%);
  @media (max-width: ${lg}) {
    font-size: 1em;
    text-align: left;
  }
`;
export const Consecutive = styled(TextField)`
  width: 100%;
  background-color: #f8f8f8;
  color: hsl(0, 0%, 50%);
  font-size: 1em;
  @media (max-width: ${lg}) {
    font-size: 1em;
    text-align: left;
  }
`;
export const Button = styled(ButtonComponent)`
  font-size: 1em;
  @media (max-width: ${lg}) {
    padding: 0.5em;
    border-radius: 0.5em;
    width: 90%;
    box-sizing: content-box;
  }
`;
export const Error = styled.div`
  position: absolute;
  top: 105%;
  font-family: Poppins Ligth;
  color: red;
`;
const color = "#f8f8f8";
export const stylesSelect = {
  container: (base: any) => ({
    ...base,
    width: "100%",
    boxSizing: "border-box",
    fontFamily: "Poppins Regular",
  }),
  control: (base: any, state: any) => ({
    ...base,
    backgroundColor: color,
    borderColor: state.isFocused ? "#a2a2a2" : "#a2a2a2",
    boxShadow: state.isFocused ? "#a2a2a2" : "#a2a2a2",
    "&:hover": {
      borderColor: state.isFocused ? "#a2a2a2" : "#a2a2a2",
      boxShadow: state.isFocused ? "#a2a2a2" : "#a2a2a2",
    },
    height: "2em",
    minHeight: 0,

    borderRadius: "0.5em",
    paddingLeft: "1em",
    textAlign: "center",
  }),
  valueContainer: (_base: any) => ({
    alignSelf: "baseline",
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    display: "none",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "hsl(0, 0%, 50%)",
    fontFamily: "Poppins Regular",
    fontSize: "0.9em",
  }),
  dropdownIndicator: (_base: any) => ({
    padding: "0 8px",
  }),
};
